import { ButtonMain } from '@quero-delivery/quero-components-web';
import { Modal } from '@querodelivery/uni-react';
import styles from './styles.module.scss';
import { useResetBalance } from '../../../../api/post-reset-balance';
import { MODAL_WIDTH } from '@/_constants/styles';

export interface ModalConfirmResetBalanceProps {
  open: boolean;
  onClose: () => void;
}

function ModalConfirmResetBalance({
  open,
  onClose,
}: ModalConfirmResetBalanceProps) {
  const { mutate: resetBalance, isLoading: isLoadingResetBalance } =
    useResetBalance();

  const handleConfirm = () => {
    resetBalance(undefined, {
      onSuccess: () => {
        onClose();
      },
    });
  };

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      width={MODAL_WIDTH.md}
      header="Resetar saldo dos entregadores"
    >
      <div className={styles.container}>
        <h5>Atenção!</h5>
        <span>Tem certeza que deseja resetar o saldo dos entregadores?</span>

        <div className={styles.containerButton}>
          <ButtonMain width="40%" secondary onClick={() => onClose()}>
            Cancelar
          </ButtonMain>

          <ButtonMain
            onClick={handleConfirm}
            width="40%"
            loading={isLoadingResetBalance}
            className={styles.buttonStyle}
            disabled={isLoadingResetBalance}
          >
            Sim, resetar o saldo!
          </ButtonMain>
        </div>
      </div>
    </Modal>
  );
}

export { ModalConfirmResetBalance };
